// extracted by mini-css-extract-plugin
export default {"input":"QtpdCI","fields":"UCFWyn","ticketValidity":"kTWYyL mz-default-dark-font"};